
/* eslint-disable no-continue */
import cssifyObject from 'css-in-js-utils/lib/cssifyObject';

import { isObject, isMediaQuery, isNestedSelector, isUndefinedValue, objectReduce, normalizeNestedProperty, processStyleWithPlugins, generateMonolithicClassName, generateCombinedMediaQuery, generateCSSSelector, generateCSSRule, RULE_TYPE } from 'fela-utils';

function useMonolithicRenderer(renderer) {
  var prettySelectors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  renderer.prettySelectors = prettySelectors;

  renderer._renderStyleToCache = function (className, style) {
    var pseudo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var media = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    var ruleSet = objectReduce(style, function (ruleset, value, property) {
      if (isObject(value)) {
        if (isNestedSelector(property)) {
          renderer._renderStyleToCache(className, value, pseudo + normalizeNestedProperty(property), media);
        } else if (isMediaQuery(property)) {
          var combinedMediaQuery = generateCombinedMediaQuery(media, property.slice(6).trim());

          renderer._renderStyleToCache(className, value, pseudo, combinedMediaQuery);
        } else {
          // TODO: warning
        }
      } else if (!isUndefinedValue(value)) {
        ruleset[property] = value;
      }

      return ruleset;
    }, {});

    if (Object.keys(ruleSet).length > 0) {
      var css = cssifyObject(ruleSet);
      var selector = generateCSSSelector(className, pseudo);
      var cssRule = generateCSSRule(selector, css);

      if (media.length > 0) {
        if (!renderer.mediaRules.hasOwnProperty(media)) {
          renderer.mediaRules[media] = '';
        }

        renderer.mediaRules[media] += cssRule;
      } else {
        renderer.rules += cssRule;
      }

      renderer._emitChange({
        selector: selector,
        declaration: css,
        media: media,

        type: RULE_TYPE
      });
    }
  };

  renderer._renderStyleToClassNames = function (style, rule) {
    if (Object.keys(style).length < 1) {
      return '';
    }

    var localRulePrefix = renderer.prettySelectors && rule.name ? rule.name + '_' : '';

    var className = generateMonolithicClassName(style, (renderer.selectorPrefix || '') + (rule.selectorPrefix || localRulePrefix));

    if (!renderer.cache.hasOwnProperty(className)) {
      renderer._renderStyleToCache(className, style);
      renderer.cache[className] = true;
    }

    return className;
  };

  renderer.renderRule = function (rule) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var processedStyle = processStyleWithPlugins(renderer, rule(props), RULE_TYPE, props);
    return renderer._renderStyleToClassNames(processedStyle, rule);
  };

  return renderer;
}

export default function monolithic() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (renderer) {
    return useMonolithicRenderer(renderer, process.env.NODE_ENV !== 'production' && options.prettySelectors);
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-monolithic/es/index.js
// module id = 784
// module chunks = 0